// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PlayArrow20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PlayArrow20CircleFilled: FC<PlayArrow20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm5.5-12L9 6.5v11l8.5-5.5Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default PlayArrow20CircleFilled;
